var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Lista firm")]),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c("v-btn", { attrs: { block: "", color: "accent" } }, [
                _vm._v("Dodaj nową firmę")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.companies,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.short_name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.alias))
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c("span"),
                      props.item.is_enabled
                        ? _c(
                            "v-chip",
                            {
                              attrs: { color: "success", "text-color": "white" }
                            },
                            [
                              _vm._v(" Włączone "),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("fa-check-circle")
                              ])
                            ],
                            1
                          )
                        : _c(
                            "v-chip",
                            { attrs: { color: "grey", "text-color": "white" } },
                            [
                              _vm._v(" Wyłączone "),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("fa-times-circle")
                              ])
                            ],
                            1
                          ),
                      props.item.TIN !== null
                        ? _c(
                            "v-chip",
                            { attrs: { color: "info", "text-color": "white" } },
                            [
                              _vm._v(" Xtur "),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("fa-check-circle")
                              ])
                            ],
                            1
                          )
                        : _c(
                            "v-chip",
                            { attrs: { color: "grey", "text-color": "white" } },
                            [
                              _vm._v(" Xtur "),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("fa-times-circle")
                              ])
                            ],
                            1
                          ),
                      props.item.is_wnb_enabled
                        ? _c(
                            "v-chip",
                            {
                              attrs: { color: "primary", "text-color": "white" }
                            },
                            [
                              _vm._v(" WNB "),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("fa-check-circle")
                              ])
                            ],
                            1
                          )
                        : _c(
                            "v-chip",
                            { attrs: { color: "grey", "text-color": "white" } },
                            [
                              _vm._v(" WNB "),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("fa-times-circle")
                              ])
                            ],
                            1
                          )
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.$refs.companyModules.open(
                                props.item.id,
                                props.item.name
                              )
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("edit")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            disabled: _vm.$store.getters["Ajax/loading"]
                          },
                          on: {
                            click: function($event) {
                              return _vm.loginInCompanyContext(props.item.id)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("transfer_within_a_station")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c("company-modules", { ref: "companyModules" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }